<app-description id="step2" [uid]="getUid()" [parentForm]="parentForm" [disabled]="disabled"
	[description]="initial?.description" [initial]="initial"></app-description>
